/**
 * EE API Role Rights 前端服務（呼叫 /api/ee/api_role_rights/*）
 */
import axios from '../api/axios';
import { I18nField } from '../types';

const BASE = '/api/ee/api_role_rights';

export interface ApiRoleRight {
  id: number;
  api_role_id: number;
  system_function_id: number;
  func_code: string;
  is_call: boolean;
  edit_by: number;
  created_at: string;
  updated_at: string;
}

export interface ApiRoleRightItem {
  system_function_id: number;
  func_code: string;
  is_call: boolean;
}

export interface AvailableService {
  system_function_id: number;
  func_code: string;
  func_name: I18nField;
  description: string | null;
}

export const listAvailableServices = async (): Promise<AvailableService[]> => {
  const res = await axios.get(`${BASE}/available_services`);
  return res.data;
};

export const listRightsByRole = async (roleId: number): Promise<ApiRoleRight[]> => {
  const res = await axios.get(`${BASE}/by_role/${roleId}`);
  return res.data;
};

export const saveRightsByRole = async (
  roleId: number,
  rights: ApiRoleRightItem[],
): Promise<ApiRoleRight[]> => {
  const res = await axios.put(`${BASE}/by_role/${roleId}`, { rights });
  return res.data;
};
